import React, { use, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils.js';
import TypedLink from '../../components/TypedLink/TypedLink.js';
import { useAppContext, useModalsContext } from '../../contexts/AppContext';
import Minicart from '../../components/Minicart/Minicart.js';
import Search from '../../components/Search/Search.js';
import ShareButton from '../../components/ShareButton/ShareButton.js';
import Accordion from '../../components/AnimatedElements/Accordion.js';
import ProductsSlider from '../../components/ProductsSlider/ProductsSlider.js';
import FavoriteIcon from '../../components/FavoreiteIcon/FavoriteIcon.js';  

import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';

import './Product.css';
import '../../components/Forms/Form.css';
import 'swiper/css';
import 'swiper/css/scrollbar';
import { object } from 'framer-motion/client';

const Product = () => {

  const location = useLocation();
  const [serverData, setServerData] = useState({});
  const [product, setProduct] = useState({});
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const { appRef } = useAppContext();
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [shippingInfo, setShippingInfo] = useState(null);
  const [ratings, setRatings] = useState([]);
  const [priceDropData, setPriceDropData] = useState({price: '', name: '', email: ''});
  const [priceDropResponse, setPriceDropResponse] = useState(null);
  const [notifyMeData, setNotifyMeData] = useState({name: '', email: ''});
  const notifyMeDataRef = useRef({name: '', email: ''});
  const [notifyMeResponse, setNotifyMeResponse] = useState(null);
  const [notifyMeResponseType, setNotifyMeResponseType] = useState('');
  const [lastVisitedProducts, setLastVisitedProducts] = useState([]);
  const hasGroupedProducts = (product?.grouped_products) ? (Object.keys(product.grouped_products).length > 1) : false;
  const [selectedProductVariant,setSelectedVariant] = useState(null);
  const [selectedVariantData, setSelectedVariantData] = useState(null);
  const productImageRef = useRef(null);
  const [selectedPackageProducts, setSelectedPackageProducts] = useState([]);
  const [selectedPackageInfo, setSelectedPackageInfo] = useState(null);

  useEffect(() => {
    if(product.id){
      Utils.get_server_data(location.pathname, {}, {ajax_event: 'get_products_more_info', product_id: product.id}).then((resp) => {
        setShippingInfo(resp.shipping_info ?? null);
        setRatings(resp.products_reviews || []);
        setLastVisitedProducts(resp.last_visited_products?.products || []);
      });
    }
  }, [product.id]);

  useEffect(() => {
    if(serverData.loaded===1){
      setProduct(serverData.product);
    }
  }, [serverData]);

  useEffect(() => {
    setActiveImageIndex(0);
  }, [product?.product_images?.length, product?.product_image?.length]);

  useEffect(() => {

    setServerData({loaded:0});
    Utils.get_server_data(location.pathname).then((resp) => {
      setServerData(resp);
    });

  }, [location]);

  function handle_fav_click(event) {

    event.preventDefault();
 
    product.fav = product.fav ? 0 : 1;

    setProduct(product);
  }

  function render_sale_badge(){
    return (parseInt(product.sale)>0 ? <div className='sale badge'>-{Math.floor(product.sale_percentage)}%</div> : '');
  }

  function render_newness_badge(){
    return (parseInt(product.newness)>0 ? <div className='newness badge'>{i18n.t('productItemNewBadge')}</div> : '');
  }

  function renderProductLabels() {
        
      const labelData = Utils.getProductLabelElement(product, 'product_details');
      
      if (!labelData) {
        return null;
      }
  
      return (
        <div className={`badge product-label`}>
          <img 
            src={process.env.REACT_APP_ORIGINAL_SHOP_URL + '/upload_files/products_parameters/' + labelData.image} 
            alt={labelData.productParameter} 
          />
        </div>
      );
    }

  function render_header_images_slider(){
    
    const productImages = Array.isArray(product?.product_images) ? product.product_images : [];
    const fallbackImages = (!productImages.length && Array.isArray(product?.product_image)) ? product.product_image : [];
    const totalSlides = productImages.length || fallbackImages.length;
    const currentIndex = Math.min(activeImageIndex, Math.max(totalSlides - 1, 0));

    return <div className='details_images_slider_cont'>
      {
        productImages.length > 0 ? (
          <Swiper
            className='details_images_slider'
            onSlideChange={(swiper) => setActiveImageIndex(swiper.activeIndex)}
          >
            {productImages.map((value, index) => (
              <SwiperSlide key={value.thumb_large_.filename} className="slider_item">
                <img ref={index === 0 ? productImageRef : null} src={process.env.REACT_APP_ORIGINAL_SHOP_URL + '/' + value.thumb_large_.filename} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : fallbackImages.length > 0 ? (
          <div className='details_images_slider_single_image'>
            <img ref={productImageRef} src={process.env.REACT_APP_ORIGINAL_SHOP_URL + '/' + fallbackImages[0].thumb_large_.filename} />
          </div>
        ) : (
          <div className='details_images_slider_single_image'>
            <img ref={productImageRef} src='assets/images/no_image.png' />
          </div>
        )
      }
      {totalSlides>1 ? <div className='details_images_slider_counter'>{currentIndex + 1} / {totalSlides}</div> : null}

    </div>;
  }

  function render_product_name_and_price(){
    
    //@todo le kell kezelni belépés utáni állapotot is
    const isProfessionalOnly = product.is_proffesional;

    return <div className='product_name_and_price'>
      <div className='product_name'><h1>{product.product}</h1></div>
      {(parseInt(isProfessionalOnly)>0) ? 
        <div className='product_price pro_product'>
          {i18n.t('productDetailsProProduct')}
        </div> : 
        <div className='product_price'>
          {parseInt(product.sale) > 0 ? <><span className='sale-price'>{product.price_gross}</span> <br/></> : ''} 
          <span className={`${parseInt(product.sale) > 0 ? 'stroked' : 'normal-price'}`}>{parseInt(product.sale) !== 0 ? product.price_original_gross : product.price_gross}</span>
          {render_sale_badge()}
          {render_product_unit_price()}
        </div>
      }
      {redner_product_stock_info()}
    </div>;
  }

  function render_product_variants_select()
  {
    if(product.grouped_products && Object.keys(product.grouped_products).length>0)
    {
      return <div className='product_variants_select_cont'>
        <div className='product_variants_select'>
          <ul>
            {Object.keys(product.grouped_products).map((key) => {
              const variant = product.grouped_products[key];
              const isSelected = selectedProductVariant === variant.id;
              if(!variant?.color?.product_parameter){return null;}

              return (
                <li key={variant.id} onClick={() => {
                  
                  const newProduct = {...variant};
                  newProduct.grouped_products = product.grouped_products;
                  newProduct.specification_blob_hu = product.specification_blob_hu;
                  setProduct(newProduct);

                  setSelectedVariant(variant.id);
                  setSelectedVariantData(variant);
                  appRef.current.closeDialog();
                }} className={isSelected ? 'selected' : ''}>
                  <span className='color-image'>
                    {variant.color.color_image ?
                    <img src={variant.color.color_image ? process.env.REACT_APP_ORIGINAL_SHOP_URL + '/upload_files/products_parameters/' + variant.color.color_image : ''} />
                    : <span className='color-code' style={{backgroundColor:variant.color.color_code}}></span>}
                  </span>
                  <span className='variant_name'>{variant.product}<br/><span>{variant.color.product_parameter}</span></span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>;
    }
  }

  function get_variant_button_style() {
    let variant = null;
    let buttonStyle = {};

    if(selectedProductVariant && product.grouped_products){
      Object.keys(product.grouped_products).forEach((key) => {
        if(product.grouped_products[key].id === selectedProductVariant){
          variant = product.grouped_products[key];
        }
      });
    }

    if(variant && variant.color){
      if(variant.color.color_image){
         buttonStyle.backgroundImage = `url(${process.env.REACT_APP_ORIGINAL_SHOP_URL}/upload_files/products_parameters/${variant.color.color_image})`;
         buttonStyle.backgroundSize = 'cover';
         buttonStyle.backgroundPosition = 'center';
      } else if(variant.color.color_code){
         buttonStyle.backgroundColor = variant.color.color_code;
      }
    }
    return buttonStyle;
  }

  function handleAddToCart(){
    const hasSelectedPackages = selectedPackageProducts.length > 0;
    
    if(hasSelectedPackages){
      
      const packageData = {
        to_shopping_cart_products_packages: 1,
        count_products_packages: selectedPackageProducts.length
      };
      
      selectedPackageProducts.forEach((pack, index) => {
        const num = index + 1;
        packageData[`pc_product_package_${num}`] = 1;
        packageData[`sql_id_product_package_${num}`] = pack.id;
      });
      
      Utils.add_product_to_shopping_cart(product.id, 1, null, productImageRef.current, packageData);
    } else {
      Utils.add_product_to_shopping_cart(product.id, 1, null, productImageRef.current);
    }
  }

  function render_product_add_to_cart(){

    const buttonStyle = get_variant_button_style();
    const hasSelectedPackages = selectedPackageProducts.length > 0;
    let showCartButton = true;
    let extra_message = '';
    const settings = appRef?.current?.state?.settings || {};
    
    const toInt = (value) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    const isNoStockNoOrderEmpty = product?.no_stock_no_order === undefined || product?.no_stock_no_order === null || `${product?.no_stock_no_order}`.trim() === '' || toInt(product?.no_stock_no_order) === 0;
    const arriveTimestamp = Number.parseInt(product?.product_arrive_time, 10);
    const nowTimestamp = Math.floor(Date.now() / 1000);

    if(product?.no_stock_only_order){
      showCartButton = false;
    }

    if (isNoStockNoOrderEmpty) {
      if (arriveTimestamp > nowTimestamp && settings?.order_width_date) {
        const arriveDate = Utils.timestampToLocalDate(arriveTimestamp);
        extra_message = `${settings.order_width_date}`.replace('{arrive_date}', arriveDate);
      } else if (settings?.order_widthout_date) {
        extra_message = settings.order_widthout_date;
      }
    }

    return <div className='product_add_to_cart'>
      {hasSelectedPackages && selectedPackageInfo?.selected_sum_price_gross && (
        <div className='package_sum_price'>
          {i18n.t('packageSumPriceLabel')} {Utils.format_currency(selectedPackageInfo.selected_sum_price_gross, appRef.current.currency_settings)}
        </div>
      )}
      {hasGroupedProducts && <div className={"select_color_variant_cont"+(selectedProductVariant ? ' selected' : '')}>
        <button style={buttonStyle} onClick={() => appRef.current.set_dialog_message(render_product_variants_select(), {cancel: true, hide_buttons: true})}>
          <ReactSVG src='/assets/images/colorpicker.svg'/><span>{i18n.t('productDetailsSelectColorVariant')}</span>
        </button>
      </div>}
      {(!hasGroupedProducts || selectedProductVariant) ?
      <>
        <div className='add_to_cart_and_fav_cont'>

          {showCartButton ? (
            <button onClick={handleAddToCart} className='add_to_cart_button'>
              {hasSelectedPackages ? i18n.t('addPackageToCart') : i18n.t('prodiuctDetailsAddToCart')}
            </button>
          ) :
            <button onClick={() => show_notify_me_dialog()} className='add_to_cart_button disabled'>
              {i18n.t('productDetailsNotifyMe')}
            </button>
          }

          
          {extra_message ? <div className='delivery_time product_order_width_message'>{extra_message}</div> : null}

        </div>
        <div className='product_fav_info'>
          <FavoriteIcon product={product} />
        </div>
      </>
      : ''}
    </div>;
  }

  function render_product_unit_price() {
    
    const hasUnitData = product?.unit_divisor && product?.unit_meausre && !parseInt(product?.is_service);

    if (hasUnitData) {


      const unitDivisor = Number(product.unit_divisor);
      const unitPriceRaw = Utils.format_currency((product.price_o / unitDivisor),appRef.current.currency_settings);

      const unitLabel = product.unit_meausre?.product_parameter || '';

      return (
        <div className='quantity_unit_price'>
          {unitPriceRaw} {unitLabel ? `/ ${unitLabel}` : ''}
        </div>
      );

    }

    return <div className='quantity_unit_price' style={{ height: '20px', padding: 0 }}></div>;
  }

  function redner_product_stock_info() 
  {
    const stockState = product?.stock_state;

    if (!stockState || typeof stockState !== 'object') {
      return null;
    }

    const toInt = (value) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    };

    const predictedDaysRaw = product?.predicted_delivery_days;
    const predictedDays = `${predictedDaysRaw ?? ''}`.trim();
    const hasPredictedDays = predictedDays !== '' && predictedDays !== '0';
    const hasAvailableStock = toInt(product?.stock_pc) > 0 || toInt(product?.run_out_of_stock) !== 1;
    const isActive = toInt(product?.active) === 1;
    const noBasketRaw = product?.no_basket;
    const isBasketAllowed = noBasketRaw === undefined || noBasketRaw === null || `${noBasketRaw}`.trim() === '' || toInt(noBasketRaw) === 0;
    const canShowPredictedDelivery = hasPredictedDays && hasAvailableStock && isActive && isBasketAllowed;
    const arriveTimestamp = toInt(product?.product_arrive_time);

    const colorStyle = stockState.color_code ? { color: stockState.color_code } : undefined;
    const label = stockState.product_parameter;

    if (!label) {
      return null;
    }

    return (
      <div className='stock_info'>
        <div className='state_info_label' style={colorStyle}>{label}</div>
        {arriveTimestamp > 0 ? (
        <div className="delivery_time product_arrive_date">
          {i18n.t('productDetailsArrive')} {Utils.timestampToLocalDate(product.product_arrive_time)}
        </div>) : canShowPredictedDelivery ? (
        <div className="delivery_time product_arrive_date">
          {i18n.t('productDetailsPredictedDelivery', { count: predictedDays})}
        </div>) : (
        <div className="delivery_time product_arrive_date delivery_time">
          {i18n.t('productDetailsArriveMissing')}
        </div>)}
      </div>
    );
  }

  function show_accordion_header(icon,title){
    return <div className='accordion_header_inner'>
      <ReactSVG className='accordion_icon' src={`/assets/images/${icon}`}></ReactSVG>  
      <div className='accordion_label'>{title}</div>
    </div>;
  }

  function show_accordion_content(title, text, onClose, forceHTML = false){
    return <div className='accordion_content_inner'>
      <PageHeader isHistoryBack={false}  no_close="true" title={title} callback={onClose}></PageHeader>
      {(forceHTML) ? <div className='content_text' dangerouslySetInnerHTML={{__html: text}} /> :
      <div className='content_text'>{text}</div>}
    </div>;
  }

  function render_delivery_content() {
    
    return (
        <div className="delivery_info_content">
             <div className="main_delivery_text" dangerouslySetInnerHTML={{__html: shippingInfo}} />
        </div>
    );
  }

  function render_product_properties(){
    const parameterFilters = serverData.product_parameter_filters || {};
    const properties = [];

    Object.entries(product).forEach(([key, value]) => {
      if (
        value &&
        typeof value === 'object' &&
        value.product_parameter &&
        parameterFilters[key]
      ) {
        const isManufacturer = value.product_parameter_category === 'manufacturer';
        properties.push(
          <div className="columns is-mobile is-marginless" key={key}>
            <div className="column is-narrow">{parameterFilters[key].label_txt}</div>
            <div className="column">
              {isManufacturer ? (
                <TypedLink className="" link={{url: value.url, type: 'products'}}>
                  <span>{value.product_parameter}</span>
                </TypedLink>
              ) : (
                value.product_parameter
              )}
            </div>
          </div>
        );
      }
    });

    if (properties.length === 0) {
      return null;
    }

    return (
      <div className="prod_prop_line">
        <div className="prod_desc_content">
           {properties}
        </div>
      </div>
    );
  }

  function render_product_ratings_icon(){
    if(parseInt(product.product_rating_count || 0) <= 0){
      return null;
    }
    const stars = product.product_rating_average || 0;
    const stars_array = ['empty','empty','empty','empty','empty'];
    const half_star = (stars % 1) >= 0.5;

    for(let i=0;i<Math.floor(stars);i++){
      stars_array[i] = 'full';
    }

    if(half_star){
      stars_array[Math.floor(stars)] = 'half';
    }

    return <div className='product_ratings_row' key={"rating_icon_"+product.product_rating_count+' '+product.product_rating_average}>
      <div className='product_ratings_icon'><ReactSVG className='star_icon' src={`/assets/images/product_rating_icon.svg`}></ReactSVG></div>
      <div className='product_ratings_text'>
        <div className='product_ratings_label'>{i18n.t('productItemRatingsCount', { count: product.product_rating_count || 0 })}</div>
        <div className='product_ratings_rating_stars'>
          <div className='produt_ratings_text'>{product.product_rating_average} / 5</div>
          <div className='product_ratings_stars_cont'>
            <div className='product_ratings_stars_inner'>
              {stars_array.map((star_type, index) => {
                return <ReactSVG key={index} className={'star_icon '+ star_type} src={`/assets/images/star.svg`}></ReactSVG>;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  function render_product_feedback(){
    return <div className='product_feedback_section'>
      <div className='product_feedback_list'>
        {render_product_ratings_icon()}
        {
          ratings.length > 0 ? ratings.map((rating) => {
            
            const stars = Math.floor(rating.product_rating);
            const stars_array = ['empty','empty','empty','empty','empty'];
            const half_star = (rating.product_rating % 1) >= 0.5;

            for(let i=0;i<stars;i++){
              stars_array[i] = 'full';
            }

            if(half_star && stars < 5){
              stars_array[stars] = 'half';
            }

            return <div key={rating.id} className='product_feedback_item'>
              <div className='feedback_header'>
                <div className='feedback_rating_stars'>
                  <div className='product_ratings_stars_cont'>
                    <div className='product_ratings_stars_inner'>
                      {stars_array.map((star_type, index) => {
                        return <ReactSVG key={index} className={'star_icon '+ star_type} src={`/assets/images/star.svg`}></ReactSVG>;
                      })}
                    </div>
                    <span className='date'>{Utils.timestampToLocalDate(rating.time)}</span>
                  </div>
                </div>
                <div className='feedback_user_name_and_data'><span>{rating.firstname}</span></div>
              </div>
              <div className='feedback_comment'>
                {rating.product_review}
              </div>
            </div>;
          }) : <div className='no_feedback'>{i18n.t('productFeedbackNoFeedback')}</div>
        }
      </div>
    </div>;
  }

  function render_i_want_cheaper_content(){
    return <div className='price_drop_notification_form'>
        <div className='form_title'>
           {i18n.t('priceDropNotificationTitle')}
        </div>
        {priceDropResponse ? <div className='response_message' dangerouslySetInnerHTML={{__html: priceDropResponse}}></div> : null}
        {!priceDropResponse || priceDropResponse.indexOf('error')!==-1 ?
        <>
          <div className='form_row'>
            <input type='text' placeholder={i18n.t('priceDropPlaceholderPrice')} value={priceDropData.price} onChange={(e) => setPriceDropData({...priceDropData, price: e.target.value})} />
          </div>
          <div className='form_row'>
              <input type='text' placeholder={i18n.t('priceDropPlaceholderName')} value={priceDropData.name} onChange={(e) => setPriceDropData({...priceDropData, name: e.target.value})} />
          </div>
          <div className='form_row'>
              <input type='email' placeholder={i18n.t('priceDropPlaceholderEmail')} value={priceDropData.email} onChange={(e) => setPriceDropData({...priceDropData, email: e.target.value})} />
          </div>
          <div className='form_submit'>
              <button className='submit_btn' onClick={sendPriceDropData}>{i18n.t('priceDropSubmitBtn')}</button>
          </div>
        </>
        : null}
        
    </div>
  }

  function handlePackageToggle(pack){
    const isSelected = selectedPackageProducts.some(p => p.id === pack.id);
    let newSelected;
    if(isSelected){
      newSelected = selectedPackageProducts.filter(p => p.id !== pack.id);
    } else {
      newSelected = [...selectedPackageProducts, pack];
    }
    setSelectedPackageProducts(newSelected);

    const selectedIds = newSelected.map(p => p.id).join('|');
    Utils.get_server_data(
      location.pathname,
      {},
      {
        ajax_event: 'update_product_gifts_and_packages',
        packages_parent_product: product.id,
        selected_package_products: selectedIds
      }
    ).then((resp) => {
      if(resp?.products?.product_page_products?.products[0]){
        setSelectedPackageInfo(resp.products.product_page_products.products[0].products_packages_info || null);
      }
    });
  }

  function render_product_packages(){
    if(product?.products_packages?.products?.length > 0){
      return <div className='product_packages_cont'>
        <div className='product_packages_toggle_badge'>
          <div className='product_packages_label'>{i18n.t('productPackagesLabel')}</div>
        </div>
        <div className='product_packages_list'> 
          {product.products_packages.products.map((pack) => {
            const isSelected = selectedPackageProducts.some(p => p.id === pack.id);
            return <div key={pack.id} className={`product_package_item${isSelected ? ' selected' : ''}`}>
              <div className='package_product_image'>
                <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+pack.product_image[0]['thumb_small_'].filename}/>
              </div>
              <div className='package_product_name'>{pack.product}</div>
              <div className='package_prices_row'>
                <div className='package_product_price original_price'>
                  <span className='label'>{i18n.t('packageOriginalPrice')}</span>
                  {Utils.format_currency(pack.price_gross, appRef.current.currency_settings)}
                </div>
                <div className='package_product_price package_price'>
                  <span className='label'>{i18n.t('packagePrice')}</span>
                  {Utils.format_currency(pack.product_package_price_gross, appRef.current.currency_settings)}
                </div>
              </div>
              <button 
                className={`package_toggle_btn${isSelected ? ' remove' : ' add'}`}
                onClick={() => handlePackageToggle(pack)}
              >
                {isSelected ? i18n.t('removeFromPackage') : i18n.t('addToPackage')}
              </button>
              
            </div>;
          })}
        </div>
      </div>;
    }
  }

  function sendPriceDropData(){

    Utils.get_server_data(
      location.pathname, 
      {}, 
      {
        ajax_event: 'i_want_discount_notification', 
        product_id: product.id, 
        cheaper_price: priceDropData.price, 
        prod_code: product.product_code, 
        prod_groupcode: product.groupcode,
        prod_price: Math.round(parseFloat(product.price_o)),
        cheaper_name: priceDropData.name, 
        cheaper_email: priceDropData.email
      })
      .then((resp) => {
        if(resp?.cheaper_response){
          setPriceDropResponse(resp.cheaper_response);
        }
    });
  }

  function render_notify_me_dialog_content(dialogNotifyData = notifyMeData, dialogNotifyResponse = notifyMeResponse, dialogNotifyResponseType = notifyMeResponseType){
    return <div className='notify_me_form'>
        <button className='modal-close-btn' onClick={() => appRef.current.closeDialog()}>
          <ReactSVG src="/assets/images/close.svg" />
        </button>
        <div className='form_title'>
           {i18n.t('notifyMeDialogTitle')}
        </div>
        {dialogNotifyResponse ? <div className={`response_message ${dialogNotifyResponseType}`}>{dialogNotifyResponse}</div> : null}
        {!dialogNotifyResponse || dialogNotifyResponseType === 'error' ?
        <>
          <div className='form_row'>
            <input
              type='text'
              defaultValue={dialogNotifyData?.name || ''}
              placeholder={i18n.t('notifyMeNamePlaceholder')}
              onChange={(e) => {
                const value = e.target.value;
                notifyMeDataRef.current = {...notifyMeDataRef.current, name: value};
                setNotifyMeData((prev) => ({...prev, name: value}));
              }}
            />
          </div>
          <div className='form_row'>
            <input
              type='email'
              defaultValue={dialogNotifyData?.email || ''}
              placeholder={i18n.t('notifyMeEmailPlaceholder')}
              onChange={(e) => {
                const value = e.target.value;
                notifyMeDataRef.current = {...notifyMeDataRef.current, email: value};
                setNotifyMeData((prev) => ({...prev, email: value}));
              }}
            />
          </div>
          <div className='form_submit'>
            <button className='submit_btn' onClick={sendNotifyMeData}>{i18n.t('notifyMeSubmitBtn')}</button>
          </div>
        </>
        : null}
    </div>;
  }

  function show_notify_me_dialog(){
    setNotifyMeResponse(null);
    setNotifyMeResponseType('');
    notifyMeDataRef.current = {name: '', email: ''};
    setNotifyMeData({name: '', email: ''});
    appRef.current.set_dialog_message(
      render_notify_me_dialog_content({name: '', email: ''}, null, ''),
      {cancel: true, hide_buttons: true}
    );
  }

  function sendNotifyMeData(){
    const name = (notifyMeDataRef.current?.name || '').trim();
    const email = (notifyMeDataRef.current?.email || '').trim();
    const normalizeMessage = (message) => String(message || '').replace(/<[^>]*>/g, '').trim();

    Utils.get_server_data(
      location.pathname,
      {},
      {
        ajax_event: 'write_notify_me',
        notify_datas: JSON.stringify({
          name,
          email,
          pid: product?.id || 0,
          pcode: product?.product_code || product?.groupcode || ''
        })
      }
    ).then((resp) => {
      const notificationResp = resp?.stock_nofification || {};

      if (notificationResp.error) {
        const errorMessage = normalizeMessage(notificationResp.error);
        setNotifyMeResponse(errorMessage);
        setNotifyMeResponseType('error');

        appRef.current.set_dialog_message(
          render_notify_me_dialog_content({name, email}, errorMessage, 'error'),
          {cancel: true, hide_buttons: true}
        );
        return;
      }

      if (notificationResp.success) {
        const successMessage = normalizeMessage(notificationResp.success);
        setNotifyMeResponse(successMessage);
        setNotifyMeResponseType('success');

        appRef.current.set_dialog_message(
          render_notify_me_dialog_content({name, email}, successMessage, 'success'),
          {cancel: true, hide_buttons: true}
        );
      }
    });
  }

  function render_accordion_sections(product){

    const accordion_sections = [];

    accordion_sections.push(
      <Accordion 
        key="i_want_cheaper" 
        animationType="slide-right" 
        id="i_want_cheaper" 
        header={show_accordion_header('i_want_discount.svg',i18n.t('iWantCheaperTab'))} 
        isOpen={activeAccordion === 'i_want_cheaper'}
        onToggle={(val) => setActiveAccordion(val)}
        content={show_accordion_content(i18n.t('iWantCheaperTab'), render_i_want_cheaper_content(), () => {
          setActiveAccordion(null);
        })}>
      </Accordion>
    );


    accordion_sections.push(
      <Accordion 
        key="delivery_prices" 
        animationType="slide-right" 
        id="delivery_prices" 
        header={show_accordion_header('delivery_icon.svg',i18n.t('deliveryPricesTab'))} 
        isOpen={activeAccordion === 'delivery_prices'}
        onToggle={(val) => setActiveAccordion(val)}
        content={show_accordion_content(i18n.t('deliveryPricesTab'), render_delivery_content(), () => {
          setActiveAccordion(null);
        })}>
      </Accordion>
    );

    accordion_sections.push(
      <Accordion 
        key="product_description" 
        animationType="slide-right" 
        id="product_description" 
        header={show_accordion_header('description_icon.svg',i18n.t('productDescriptionTab'))} 
        isOpen={activeAccordion === 'product_description'}
        onToggle={(val) => setActiveAccordion(val)}
        content={show_accordion_content(i18n.t('productDescriptionTab'), product.specification_blob_hu, () => {
          setActiveAccordion(null);
        },true)}>
      </Accordion>
    );

    accordion_sections.push(
      <Accordion 
        key="product_properties" 
        animationType="slide-right" 
        id="product_properties" 
        header={show_accordion_header('properties_icon.svg',i18n.t('productPropertiesTab'))} 
        isOpen={activeAccordion === 'product_properties'}
        onToggle={(val) => setActiveAccordion(val)}
        content={show_accordion_content(i18n.t('productPropertiesTab'), render_product_properties(), () => {
          setActiveAccordion(null);
        })}>
      </Accordion>
    );

    accordion_sections.push(render_product_ratings_icon());

    accordion_sections.push(
      <Accordion 
        key="product_feedback" 
        animationType="slide-right" 
        id="product_feedback" 
        header={show_accordion_header('product_feedback.svg',i18n.t('productFeedbackTab',{count: ratings.length}))} 
        isOpen={activeAccordion === 'product_feedback'}
        onToggle={(val) => setActiveAccordion(val)}
        content={show_accordion_content(i18n.t('productFeedbackTab',{count: ratings.length}), render_product_feedback(), () => {
          setActiveAccordion(null);
        })}>
      </Accordion>
    );

    return <div className='product_accordion_sections'>
      <ul>
        {accordion_sections}
      </ul>
    </div>;
  }

  return (
    <>
      {
        (serverData.loaded===1)
        ?
        <div className={`container floating_container products_details`}>
            <PageHeader isHistoryBack="true"  no_close="true" custom_icons={[<ShareButton url={serverData.share.url} title={serverData.share.title} description={serverData.share.description}></ShareButton>,<Minicart></Minicart>]} title={<Search />} ></PageHeader>
            <div className='products_details_inner'>
              {render_newness_badge()}
              {renderProductLabels()}
              {render_header_images_slider()}
              {render_product_name_and_price()}
              <div className='product_code_and_loyalty'>
                <div className='product_code'>{i18n.t('productDetailsProductCode')}{product.product_code}</div>
                {parseInt(product.loyalty_points_value)>0 ? <div className='product_loyalty'><img src='/assets/images/heart.png' alt="Loyalty Heart"/>{i18n.t('productDetailsLoyaltyPoints', { count: product.loyalty_points_value })}</div> : null}
              </div>

              {(() => {
                
                const discountGroups = product.settings_discount_group_products;

                if (!discountGroups || Object.keys(discountGroups).length === 0) return null;

                const usedLabels = new Set();
                const items = [];

                Object.values(discountGroups).forEach((v) => {
                  if (v.category == 1 && v.group_label && !usedLabels.has(v.group_label)) {
                    usedLabels.add(v.group_label);
                    items.push(<div key={v.group_label} className="action_item">{v.group_label}</div>);
                  }
                });

                return items.length > 0 ? <div className="action_line">{items}</div> : null;
              })()}
              
              <div className='separator'></div>

              {render_accordion_sections(product)}

              <div className='separator'></div>

              {render_product_packages()}

              <div className='separator'></div>

              {product.connected_products && product.connected_products.length > 0 ?
              <>
                <div className='separator'></div>
                <div className='products_details_products_slider_cont '>
                  <ProductsSlider
                    boxTitle={i18n.t('productDetailsMoreProductsTitle')}
                    products={product.connected_products || []}
                    backgroundColor="transparent"
                    productBoxType={'default'}
                    slideItemCount={1}
                    showFavIcon={true}
                    showDots={false}
                  >
                  </ProductsSlider>
                </div>
              </>
              : null}

              {lastVisitedProducts && lastVisitedProducts.length > 0 ?
              <>
                <div className='separator'></div>
                <div className='products_details_products_slider_cont '>
                  <ProductsSlider
                    boxTitle={i18n.t('productDetailsLastVisitedTitle')}
                    products={lastVisitedProducts || []}
                    backgroundColor="transparent"
                    productBoxType={'default'}
                    slideItemCount={1}
                    showFavIcon={true}
                    showDots={false}
                  >
                  </ProductsSlider>
                </div>
                <div className='separator'></div>
              </>
              : null}

            </div>
            
            {render_product_add_to_cart()}
        </div>
        :
        <div className='loader_cont'><div className='loader'><ReactSVG src='/assets/images/loading.svg'></ReactSVG></div></div>
      }
    </>
  );

};

export default Product;